import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useMediaQuery } from 'react-responsive';

const TeamMemberItem = ({ member }) => {
  const [expanded, setExpanded] = useState(false);
  const words = member.description;
  const breakText = "<div class='h-3' /></div>";
  const isLong = words.includes(breakText);
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  const shortText = words.split(breakText)[0];
  const hiddenText = words.split(breakText).slice(1).join(breakText);

  return (
    <div
      key={member.id}
      id={member.id}
      className="flex flex-col sm:flex-row items-start gap-4 sm:gap-12 mb-20 md:mb-0"
    >
      <div className="flex-1">
        <motion.div
          initial={{ opacity: 0, x: isMobile ? 0 : -300 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: 'easeInOut' }}
          viewport={{ once: true, amount: 0.5 }}
        >
          <img
            loading="lazy"
            src={require(
              `../../../assets/images/team_screen/${member.imageUrl}`
            )}
            alt={`${member.id}_image`}
            className="rounded-[40px] [clip-path:inset(3px)]"
          />
        </motion.div>
      </div>

      <div className="flex-1">
        <motion.div
          initial={{ opacity: 0, x: isMobile ? 50 : 300 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: 'easeInOut' }}
          viewport={{ once: true, amount: 0.5 }}
        >
          <h3 className="text-[30px] sm:text-[34px] md:text-[40px] text-white font-bold leading-tight">
            {member.name}
          </h3>
          {member.position && (
            <p className="text-[30px] sm:text-[34px] md:text-[40px] text-white font-bold leading-tight mb-4">
              {member.position}
            </p>
          )}

          {/* Description Text */}
          {!isLong ? (
            <p
              className="text-white font-light text-lg md:text-xl 2xl:text-2xl"
              dangerouslySetInnerHTML={{ __html: member.description }}
            />
          ) : (
            <>
              <p
                className="text-white font-light text-lg md:text-xl 2xl:text-2xl"
                dangerouslySetInnerHTML={{ __html: shortText }}
              />
              <motion.p
                initial={{ height: 0, opacity: 0 }}
                animate={{
                  height: expanded ? 'auto' : 0,
                  opacity: expanded ? 1 : 0,
                }}
                transition={{ duration: 0.5, ease: 'easeInOut' }}
                className="overflow-hidden"
              >
                <span
                  className="text-white font-light text-lg md:text-xl 2xl:text-2xl mt-2"
                  dangerouslySetInnerHTML={{ __html: hiddenText }}
                />
              </motion.p>

              <button
                onClick={() => setExpanded(!expanded)}
                className="mt-2 text-white text-lg md:text-xl 2xl:text-2xl font-bold transition"
              >
                {expanded ? 'READ LESS <' : 'READ MORE >'}
              </button>
            </>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default TeamMemberItem;
